import { Constants } from "../utils/constants"
import { api } from "./api"
import { guestApi } from "./GuestApiAccess";

export const getDomainsMaster = async () => {
    return guestApi.get(Constants.URL.domains)
        .then(res => res)
        .catch(error => console.error(error))
};


export const getDesignationMaster= async () => {
    return guestApi.get(Constants.URL.designations)
        .then(res => res)
        .catch(error => console.error(error))
};



export const getEmployeeRangeMaster= async () => {
    return guestApi.get(Constants.URL.employeeRange)
        .then(res => res)
        .catch(error => console.error(error))
};


export const getcurrentSourceMaster= async () => {
    return guestApi.get(Constants.URL.currentSource)
        .then(res => res)
        .catch(error => console.error(error))
};



export const getcurrentChannelMaster= async () => {
    return guestApi.get(Constants.URL.currentChannel)
        .then(res => res)
        .catch(error => console.error(error))
};






export const getIndustryRangeMaster= async () => {
    return guestApi.get(Constants.URL.industryRange)
        .then(res => res)
        .catch(error => console.error(error))
};




export const getfacilityConfigurationMaster= async () => {
    return guestApi.get(Constants.URL.facilitycong)
        .then(res => res)
        .catch(error => console.error(error))
};





export const getProductGroupConfigurationMaster= async () => {
    return guestApi.get(Constants.URL.productGroup)
        .then(res => res)
        .catch(error => console.error(error))
};
export const getProductSubGroupConfigurationMaster= async () => {
    return guestApi.get(Constants.URL.productSubGroup)
        .then(res => res)
        .catch(error => console.error(error))
};

export const getleadCurrencyMaster= async () => {
    return guestApi.get(Constants.URL.leadCurrency)
        .then(res => res)
        .catch(error => console.error(error))
};



export const getAccountRegionMaster= async () => {
    return guestApi.get(Constants.URL.accountRegion)
        .then(res => res)
        .catch(error => console.error(error))
};


export const getorganizationTypeMaster= async () => {
    return guestApi.get(Constants.URL.organizationType)
        .then(res => res)
        .catch(error => console.error(error))
};



export const getcountryConfigurationMaster= async () => {
    return guestApi.get(Constants.URL.countryConf)
        .then(res => res)
        .catch(error => console.error(error))
};



export const getsetdeclineReasonMaster= async () => {
    return guestApi.get(Constants.URL.declineReason)
        .then(res => res)
        .catch(error => console.error(error))
};






export const getNegotiationReasonMaster= async () => {
    return guestApi.get(Constants.URL.negotiationReason)
        .then(res => res)
        .catch(error => console.error(error))
};



export const getCountryMobileCodes = async () => {
    return guestApi.get(Constants.URL.countryMobileCode)
}


export const getPartnershipMaster = async (contractType) => {
   
    return api.get(contractType?.split("_")?.includes("ELITE")
?Constants.URL.partnerElitePrograms:Constants.URL.partnerPlusPrograms)
        .then(res => res)
        .catch(error => console.error(error))
};